import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeIdentityDomain } from './domain/identity/IdentityDomainFactory';
import { SupabaseAuthAdapter } from './infrastructure/supabase/SupabaseAuthAdapter';
import { SupabaseIdentityRepository } from './infrastructure/supabase/SupabaseIdentityRepository';
import { SupabaseManagerRepository } from './infrastructure/supabase/SupabaseManagerRepository';

// Initialize Identity Domain
initializeIdentityDomain(
  new SupabaseAuthAdapter(),
  new SupabaseIdentityRepository(),
  new SupabaseManagerRepository()
);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Đăng ký Service Worker (PWA – cache tài nguyên, chạy ngoại tuyến)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    // Trong môi trường dev, huỷ đăng ký service worker để không block Vite HMR
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let r of registrations) {
        r.unregister();
      }
    });
  } else {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(
        () => { },
        (err) => console.warn('[PWA] Service Worker đăng ký thất bại:', err.message)
      );
    });
  }
}
